export default __webpack_public_path__ + "static/media/vip-11.fbd34ef2.svg";